import { useEffect, useState } from "react";
import { enablePush, syncPush, pushSupported, permission } from "@/lib/push";
import { Bell, BellRing, Loader2 } from "lucide-react";

const T = {
  nl: { on: "Meldingen staan aan", off: "Meldingen bij nieuwe berichten", denied: "Meldingen geblokkeerd in je instellingen" },
  en: { on: "Notifications are on", off: "Notify me of new messages", denied: "Notifications blocked in your settings" },
  de: { on: "Benachrichtigungen aktiv", off: "Bei neuen Nachrichten benachrichtigen", denied: "Benachrichtigungen in den Einstellungen blockiert" },
  es: { on: "Notificaciones activadas", off: "Avisarme de nuevos mensajes", denied: "Notificaciones bloqueadas en tus ajustes" },
};

export const GuestPushButton = ({ token, lang = "nl" }) => {
  const t = T[lang] || T.nl;
  const [state, setState] = useState(permission() === "denied" ? "denied" : "idle");
  useEffect(() => { syncPush(token).then((ok) => ok && setState("on")); }, [token]);
  if (!pushSupported()) return null;
  const turnOn = async () => {
    setState("busy");
    try { await enablePush(token); setState("on"); } catch (e) { setState(e.message === "denied" ? "denied" : "idle"); }
  };
  return (
    <button onClick={turnOn} disabled={state === "busy" || state === "on" || state === "denied"}
      className="mt-3 inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-white/20 hover:bg-white/30 text-white text-sm font-medium w-fit disabled:opacity-90"
      data-testid="guest-push-btn">
      {state === "busy" ? <Loader2 className="h-4 w-4 animate-spin" /> : state === "on" ? <BellRing className="h-4 w-4" /> : <Bell className="h-4 w-4" />}
      {state === "on" ? t.on : state === "denied" ? t.denied : t.off}
    </button>
  );
};
